export const V4 = {
  primary: '#253746',
  primaryDark: '#18242E',
  primaryDeepest: '#111A22',
  secondary: '#4298B5',
  secondaryDark: '#2D6F86',
  secondaryLight: '#57BDE3',
  info: '#00B7C2',
  accent: '#08C380',
  accentMint: '#1FC49A',
  success: '#04AF00',
  danger: '#FF3939',
  dangerAlt: '#D54C4C',
  warning: '#FEAE33',
  white: '#FFFFFF',
  grayLight: '#E5ECEE',
  grayUltraLight: '#EDF5F7',
  grayBg: '#F4F4F4',
  grayBlueLight: '#F2F6F8',
  gray: '#BFD3D9',
  grayDark: '#ADB6B9',
  grayStack: '#828282',
  grayUltraDark: '#6B6B6B',
  dark: '#222424',
  // Extended palette — from colors_and_type.css
  primaryLight: '#3D5A73',
  primaryFaded: '#B7C9D8',
  secondaryLight2: '#7EBACF',
  secondaryFaded: '#D0F2FF',
  infoDark: '#007F87',
  infoLight: '#44E7F1',
  infoFaded: '#CCFCFF',
  light: '#FFFEFC',
  accentDark: '#059360',
  accentLight: '#36EDAB',
  accentFaded: '#CBFFEC',
  warningDark: '#FD9900',
  warningLight: '#F9C87C',
  warningFaded: '#FFF3E0',
  warningYellow: '#F2C94C',
  dangerDark: '#E01818',
  dangerLight: '#FE7A7A',
  dangerFaded: '#FFD8D8',
  successDark: '#037E00',
  successLight: '#6EFE6B',
  successFaded: '#D1FFD0',
  help: '#995ED6',
  helpDark: '#5D4DBA',
  helpLight: '#C593F9',
  helpFaded: '#ECDDFC',
  whatsappDark: '#04AF00',
  redNotification: '#F91515',
  surfaceDark: '#575757',
  grayStackTitle: '#333333',
} as const;
